import $ from 'jquery';
import customevent from '../../common/js/customevent/customevent';

const self = {
  elems: null,
  init () {
    if ($('.reveal-it-disabled').length) {
      return;
    }
    self.elems = $('.reveal-it');
    self.initTransition();
  },
  reInit () {
    self.init();
  },
  initTransition () {
    self.elems.addClass('reveal-it-loaded');
    $(document).ready(() => {
      const reqFrame = (window.requestAnimationFrame ? window.requestAnimationFrame : window.setTimeout);
      reqFrame(() => { // required if elements do not have the correct size yet on page load
        self.onScrollTransition();
        $(window).unbind('scroll', self.onScrollTransition);
        $(window).bind('scroll', self.onScrollTransition);
      });
    });
  },
  isSmallerThanQuarterWindow (windowHeight, elem) {
    return elem.height() < windowHeight * 0.25;
  },
  isEndOfPage (windowHeight, elem, percent) {
    const documentHeight = $(document).height();
    return elem.offset().top >= documentHeight - windowHeight * percent;
  },
  refresh () {
    self.onScrollTransition();
  },
  onScrollTransition () {
    const scrollTop = $(window).scrollTop();
    let windowHeight = $(window).height();
    if ($('html').hasClass('iPad')) {
      windowHeight = window.innerHeight ? window.innerHeight : $(window).height();
      windowHeight += 20;
    }
    self.elems.each((i, elem) => {
      const $elem = $(elem);
      if (scrollTop + (windowHeight * 0.75) >= $elem.offset().top) {
        self.revealItem($elem);
      } else if (self.isSmallerThanQuarterWindow(windowHeight, $elem) && self.isEndOfPage(windowHeight, $elem, 0.25)) {
        if (scrollTop + (windowHeight - $elem.height()) >= $elem.offset().top) {
          self.revealItem($elem);
        } else {
          $elem.removeClass('view');
        }
      } else {
        $elem.removeClass('view');
      }
    });
  },
  revealItem (elem) {
    if (!elem.hasClass('view')) {
      elem.addClass('view');
      elem[0].dispatchEvent(customevent.createCustomEvent('revealit'));
    }
  },
};
window.RevealIt = self;

$(document).ready(() => {
  self.init();
});



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/components/basepage/_reveal-it.js